<template>
    <div
        class="panel-basemaps"
        :class="[baseClass, {'panel-show': show}]"
        :style="{top: `${position.top}`, left: `${position.left}`, bottom: `${position.bottom}`, right: `${position.right}`}"
        @mouseleave="onMouseLeave">
            <div class="d-flex flex-column basemaps-container">
                <div class="d-flex flex-column overlayers" v-if="hasOverLayers()">
                    <span class="header d-none">
                        {{ $t(`${idPanel}.help.overlayer.title`) }}
                    </span>
                    <div class="row no-gutters">
                        <div class="col-6 col-sm"
                            v-for="(layer, index) in overLayers()"
                            :key="`overlayer-${index}`">
                            <label :class="['card-group-toggle', {'active': (form.overlayers ?? []).includes(layer.get('id'))}]">
                                <input type="checkbox"
                                    :name="`overlayer-${layer.get('id')}`"
                                    :id="`overlayer-${layer.get('id')}`"
                                    :value="layer.get('id')"
                                    v-model="form.overlayers">
                                <div class="card">
                                    <div class="card-body">
                                        <img class="small" :src="layer.get('img')" :alt="layer.get('name')" :title="layer.get('tooltip')">
                                        <span class="name">
                                            {{ layer.get('name') }}
                                        </span>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div>
                        <hr class="my-2"/>
                    </div>
                </div>
                <div class="d-flex flex-column baselayers">
                    <span class="header separator d-none">
                        {{ $t(`${idPanel}.help.baselayer.title`) }}
                    </span>
                    <div class="row no-gutters">
                        <div class="col-6 col-sm"
                            v-for="(layer, index) in baseLayers()"
                            :key="`baselayer-${index}`">
                            <label :class="['card-group-toggle', {'active': form.baselayer_id == layer.get('id')}]">
                                <input type="radio"
                                    name="baselayer_id"
                                    :id="`baselayer-${layer.get('id')}`"
                                    :value="layer.get('id')"
                                    v-model="form.baselayer_id">
                                <div class="card">
                                    <div class="card-body">
                                        <img :src="layer.get('img')" :alt="layer.get('name')" :title="layer.get('tooltip')">
                                        <span class="name">
                                            {{ layer.get('name') }}
                                        </span>
                                    </div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>

            </div>
    </div>
</template>

<script>
    import ButtonControlMixin from '../mixins/ButtonControlMixin';
    import { isNullOrUndefined } from '@config/utils';
    import { detectMobile } from "@config/browser";
    import NoImageIcon from '@images/no-image.jpg';
    import { POSITION } from '../ol/Control';

    let timerLeave = null;
    let layers = [];
    const LAYER_BASE = 'base';
    const LAYER_OVERLAY = 'overlay';

    export default {
        mixins: [
            ButtonControlMixin
        ],
        data() {
            return {
                idPanel: 'layerswitcher',
                className: 'ol-layerswitcher',
                baseClass: 'basemaps',
                position: {
                    top: 'auto',
                    left: 'auto',
                    right: 'auto',
                    bottom: 'auto',
                },
                form: {
                    baselayer_id: null,
                    overlayers: null,
                }
            }
        },
        computed: {
            noImageIcon() {
                return NoImageIcon;
            },
            show() {
                return this.isActive && this.isPanelVisible;
            },
            isTopPosition() {
                return [
                    POSITION.TOP_LEFT_VERTICAL,
                    POSITION.TOP_LEFT_HORIZONTAL,
                    POSITION.TOP_RIGHT_VERTICAL,
                    POSITION.TOP_RIGHT_HORIZONTAL
                ].includes(this.posBtnMap);
            },
            isMobile: {
                cache: false,
                get(){ return detectMobile() }
            },
        },
        methods: {
            onMouseLeave(evt) {
                this.clearTimeout();
                timerLeave = setTimeout(() => {
                    this.toggleMapPanel();
                }, 1000);
            },
            clearTimeout() {
                if (timerLeave) {
                    clearTimeout(timerLeave);
                    timerLeave = null;
                }
            },
            toggleMapPanel(params = this.idPanel) {
                this.clearTimeout();
                this.$store.dispatch(`${this.moduleCode}/togglePanel`, params);
            },
            addButtonMap(_map){
                this.setDefaultLayers();
                if(this.hasLayers()){
                    let btn = _map.createBtnImg(
                        this.assetsPathTheme('/map/layerswitcher.svg'),
                        _map.getControlClassName(this.orderClassName),
                        this.title,
                        [
                            {
                                type: 'click',
                                event: (evt) =>
                                {
                                    this.toggleMapPanel();
                                    evt.stopPropagation();
                                }
                            }
                        ],
                        this.lblBtn,
                        'no-filter w-img-size'
                    );
                    _map.addControl(this.posBtnMap, btn);
                    this.$nextTick(() => {
                        this.form.baselayer_id = this.currentBaseLayerId();
                        this.form.overlayers = this.currentOverLayerIds();
                        let element = $(this.ctrl?.element);
                        if(element) {
                            let offset = element.offset();
                            this.position.right = (($(window).width() - offset.left) + 10) + 'px';
                            let mobile = this.isMobile;
                            if(mobile || this.isTopPosition) {
                                this.position.top = element.parent().position().top + 'px';
                            }else{
                                this.position.bottom = ($(window).height() - offset.top - element.outerHeight()) + 'px';
                            }
                        }
                    });
                    return btn;
                }
                return false;
            },
            setDefaultLayers() {
                let _map = this.getMap();
                if(_map){
                    layers = [..._map.getLayers().getArray()].filter( function( layer, i, array ) {
                        return layer.get('by_default') === true;
                    })
                    .map(layer => {
                        if(layer.get('behavior') === LAYER_BASE) {
                            layer.set('img', layer.get('img') ?? noImageIcon);
                        }
                        return layer;
                    });
                }
            },
            layers() {
                return layers;
            },
            hasLayers() {
                return this.layers().length>0;
            },
            baseLayers() {
                return layers.filter( function( layer, i, array ) {
                    return layer.get('behavior') === LAYER_BASE;
                });
            },
            overLayers() {
                return layers.filter( function( layer, i, array ) {
                    return layer.get('behavior') === LAYER_OVERLAY;
                });
            },
            hasOverLayers() {
                return this.overLayers().length>0;
            },
            currentBaseLayer() {
                return this.baseLayers().find(layer => layer.getVisible());
            },
            currentBaseLayerId() {
                let layer = this.currentBaseLayer();
                return layer ? layer.get('id') : null;
            },
            currentOverLayers() {
                return this.overLayers().filter(layer => layer.getVisible());
            },
            currentOverLayerIds() {
                return this.currentOverLayers().map(layer => layer.get('id'));
            },
            switchBaseLayer: function(id, tooglePanel = true, force = false){
                let layer = this.baseLayers().find(layer => layer.get('id') == id);
                if(layer) {
                    if(layer.get('id') != this.currentBaseLayerId() || force) {
                        this.dispatchEventBaseLayer(layer);
                    }
                    // if(tooglePanel) {
                    //     this.toggleMapPanel();
                    // }
                }
            },
            toogleOverLayers: function(ids = [], tooglePanel = true){
                this.overLayers().forEach( (layer) => {
                    layer.setVisible(ids.includes(layer.get('id')));
                });
                // if(tooglePanel) {
                //     this.toggleMapPanel();
                // }
            },
            dispatchEventBaseLayer: function(layer) {
                let currentBaseLayer = this.currentBaseLayer();
                if(currentBaseLayer) currentBaseLayer.setVisible(false);

                if(layer){
                    layer.setVisible(true);
                    let url = layer.get('img');
                    let element = this.ctrl?.element;
                    if(element) {
                        let btn = $(element).children('button');
                        let img = btn.find('img');
                        img.fadeTo(200, 0.30, () => {
                            img.attr("src", url);
                        }).fadeTo(200, 1);
                    }
                }
            },
        },
        watch: {
            "form.baselayer_id": {
                handler: function(newValue, oldValue) {
                    if(newValue != oldValue) {
                        this.switchBaseLayer(newValue, !!oldValue, !!!oldValue);
                    }
                }
            },
            "form.overlayers": {
                deep: true,
                handler: function(newValue, oldValue) {
                    if(newValue && oldValue && newValue.length != oldValue.length) {
                        this.toogleOverLayers(newValue, !isNullOrUndefined(oldValue));
                    }
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "@styles/_mixins.scss";
    //@import "@styles/_variables.scss";
    @import "@styles/_theme.scss";

    .panel-basemaps {
        position: absolute;
        top: auto;
        bottom: auto;
        left: auto;
        right: auto;

        z-index: $zindex-content-controls;
        border: 0px;
        visibility: hidden;
        opacity: 0;
        transition: visibility 0s, opacity 0.5s linear;
        -webkit-transition: visibility 0s, opacity 0.5s linear;

        &.panel-show {
            visibility: visible;
            opacity: 1;
        }
    }

    .basemaps {
        border-radius: 8px;
        color: #202124;
        max-height: 75%;
        overflow-y: auto;
        background: rgba(255,255,255,.8);
        box-shadow: 0 0 6px 0 rgba(0,0,0,.1);
        padding: 12px;
        // background: #fff;
        // box-shadow: 0 1px 3px rgba(60,64,67,0.3), 0 4px 8px 3px rgba(60,64,67,0.15);
        // padding: 16px 24px 0 20px;
        border: 0;

        .basemaps-container {
            max-width: 270px;

            .header {
                color: $primary-color;
                font-family: $city-medium-font-family;
                font-size: 14px;
                line-height: 20px;
                margin-bottom: 8px;

                &.separator {
                    border-top: 1px solid #dadce0;
                    padding-top: 12px;
                }
            }

            .card-group-toggle {
                padding: 8px 8px;

                .card {
                    background-color: transparent;
                    border-radius: 0;
                    border: 0;
                    box-shadow: none;
                    .card-body {
                        padding: 0;
                        @include flexbox;
                        @include flex-direction(column);
                        @include flex-justify-content(center);
                        @include flex-align-items(center);

                        img {
                            background-color: #ffffff;
                            background-position: center;
                            background-size: 48px 48px;
                            border-radius: 24px; //8px;
                            border: 2px solid #fff;
                            display: inline-block;
                            height: 48px;
                            width: 48px;
                            max-width: none;
                            max-height: none;
                            filter: drop-shadow(0 0 4px rgba(0,0,0,.1)) drop-shadow(0 0 2px rgba(0,0,0,.2));

                            &.small {
                                height: 44px;
                                width: 44px;
                            }
                        }

                        .name {
                            color: #70757a;
                            display: inline-block;
                            font-size: 12px;
                            line-height: 16px;
                            margin-top: 4px;
                            text-align: center;
                            min-width: 56px;
                        }
                    }
                }

                &:hover {
                    .card {
                        .card-body {
                            img {
                                // background-clip: initial;
                                // border: 2px solid #1a73e8;
                                background-color: #f3f3f3;
                                filter: drop-shadow(0 0 2px rgba(0,0,0,.24)) drop-shadow(0 0 2px rgba(0,0,0,.2));
                                // width: 44px;
                                // height: 44px;
                            }
                            .name {
                                color: #1a73e8;
                            }
                        }
                    }
                }
                &.active {
                    .card {
                        .card-body {
                            img {
                                background-clip: content-box;
                                border: 2px solid #1a73e8;
                                // width: 40px;
                                // height: 40px;
                            }
                            .name {
                                color: #1a73e8;
                            }
                        }
                    }
                }
            }
        }
    }

</style>

